// ============================================================
// CombatRulesCard - shared "Combat Rules" card for both
// Overview sheets, rendering deriveCombatRules() output.
// ============================================================
import { memo } from 'react';
import styles from '../../styles/OverviewSheet.module.css';
import type { CombatRule } from '../../engine/combatRules';

function CombatRulesCard({ rules }: { rules: CombatRule[] }) {
  return (
    <div className={styles.card}>
      <div className={styles.cardTitle}>Combat Rules</div>
      {rules.length > 0 ? (
        <div className={styles.rulesList}>
          {rules.map((r, i) => (
            <div key={i} className={styles.ruleEntry}>
              <span className={styles.ruleName}>{r.name}</span>
              <span className={styles.ruleDesc}>{r.description}</span>
            </div>
          ))}
        </div>
      ) : (
        <div className={styles.emptyRules}>No special combat rules.</div>
      )}
    </div>
  );
}

export default memo(CombatRulesCard);
